import React, { useState, useEffect } from 'react';
import "./KineticsProvider.css"
import logo1 from "../../Includes/Images/kinetic-logo-3.png";
import provider1 from "../../Includes/Images/Rectangle-28-1.png";
import provider2 from "../../Includes/Images/retail-store-1-1.jpg";
import provider3 from "../../Includes/Images/Rectangle-15-3.png";
import provider4 from "../../Includes/Images/Rectangle-15-4.png";
import provider5 from "../../Includes/Images/Group-1171274818.png";
import provider6 from "../../Includes/Images/Group-1171274819-5.png";
import WideCoverage from './WideCoverage';
import Footer from '../../Includes/Footer';
import Header from '../../Includes/Header';

const KineticsProvider = () => {
  const [isVisible, setIsVisible] = useState(false);
  
  // Animation on scroll
  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 100);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Plan data
  const plans = [
    {
      id: 1,
      title: "PACK 1",
      subtitle: "FOR YOU",
      price: "39",
      period: "99",
      featured: false,
      features: [
        "Internet for 1 yr",
        "Unlimited Mobile plan",
        "Basic Voice Plan & Paperless",
        "Works on All Devices"
      ]
    },
    {
      id: 2,
      title: "PACK 2",
      subtitle: "BEST VALUE",
      price: "39",
      period: "99",
      featured: true,
      features: [
        "$10 Optimum-Priced Membership",
        "Internet for 1 yr with unlimited",
        "$10 Optimum-Priced Membership",
        "Works on All Devices"
      ]
    },
    {
      id: 3,
      title: "PACK 3",
      subtitle: "FOR FAMILIES",
      price: "39",
      period: "99",
      featured: false,
      features: [
        "Internet for 1 yr",
        "Unlimited Mobile plan",
        "Basic Voice Plan & Paperless",
        "Works on All Devices"
      ]
    }
  ];

  return (
    <>
    <Header/>
    <div className="kinetic-container">
      {/* Header Section */}
      <div className="kinetic-header">
        <div className="kinetic-header-content">
          <div className="kinetic-logo-section">
            <img 
              src={logo1} 
              alt="Kinetic by Windstream Logo" 
              className="kinetic-logo" 
            />
          </div>
          
          <div className="kinetic-hero-wrapper">
            <div className="kinetic-hero-content">
              <div className="kinetic-hero-text">
                <h1 className="kinetic-heading">FAST, RELIABLE<br />HIGH-SPEED<br />INTERNET</h1>
                <p className="kinetic-subheading">Our Certified Technicians Connect And Optimize Your Wi-Fi So It Works Throughout Your Home.</p>
                <a href="tel:+18443172397" className="kinetic-cta-button">
                  1 (844) 317-2397
                </a>
              </div>
              <div className="kinetic-hero-image">
                <img 
                  src={provider1} 
                  alt="Internet speeds demonstration" 
                  className="kinetic-speeds-image"
                />
              </div>
            </div>
            
            {/* WiFi Setup Box */}
            <div className="kinetic-wifi-setup">
              <h3 className="kinetic-setup-title">Wi-Fi Set Up</h3>
              <p className="kinetic-setup-text">FREE simple home set up for:</p>
              
              <div className="kinetic-plan-option">
                <h4 className="kinetic-plan-title">1-Year</h4>
                <p className="kinetic-plan-detail">Wi-Fi Extended Install</p>
              </div>
              
              <div className="kinetic-plan-option">
                <h4 className="kinetic-plan-title">3 Months</h4>
                <p className="kinetic-plan-detail">FREE Cancel Period</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Featured Products Section */}
      <section className="kinetic-featured">
        <h2 className="kinetic-section-title">Featured Products</h2>
        
        <div className="kinetic-featured-products">
          <div className="kinetic-product">
            <img 
              src={provider2} 
              alt="Kinetic by Windstream" 
              className="kinetic-product-image" 
            />
            <h3 className="kinetic-product-title">Kinetic by Windstream</h3>
            <p className="kinetic-product-desc">Delivers wireless service that meets your needs</p>
          </div>
          
          <div className="kinetic-product">
            <img 
              src={provider3}
              alt="TV Streaming" 
              className="kinetic-product-image" 
            />
            <h3 className="kinetic-product-title">TV Streaming</h3>
            <p className="kinetic-product-desc">Count on Kinetic for the best in entertainment</p>
          </div>
          
          <div className="kinetic-product">
            <img 
              src={provider4}
              alt="Home Phone" 
              className="kinetic-product-image" 
            />
            <h3 className="kinetic-product-title">Home Phone</h3>
            <p className="kinetic-product-desc">Reliable, clear Home Phone powered by our fiber-backed network</p>
          </div>
        </div>
        
        <p className="kinetic-featured-promotion">
          Learn How You Can Save $20/Month When You Purchase New Kinetic High-Speed Internet With Any New Or Existing AT&T Wireless Plan.*
        </p>
      </section>

      {/* Fiber Internet Promotion */}
      <section className={`kinetic-fiber-promo ${isVisible ? 'animate-in' : ''}`}>
        <div className="kinetic-fiber-content">
          <h2 className="kinetic-fiber-heading">GET KINETIC FIBER INTERNET</h2>
          <p className="kinetic-fiber-desc">
            New Kinetic Customers Can Save An Additional $20 Per Month When They Purchase Kinetic Fiber Internet With Any New Or Existing AT&T Wireless Plan.*
          </p>
          <a href="tel:+18443172397" className="kinetic-cta-button">
            1 (844) 317-2397
          </a>
        </div>
        
        <div className="kinetic-fiber-image">
          <div className="kinetic-price-badge">
            <span className="kinetic-starting-at">Starting at</span>
            <span className="kinetic-price">$19.99</span>
            <span className="kinetic-price-period">/mo</span>
          </div>
          <img 
            src={provider5}
            alt="Laptop with fiber internet" 
            className="kinetic-laptop-image"
          />
        </div>
      </section>

      {/* Value Proposition Section */}
      <section className="kinetic-value-prop">
        <h2 className="kinetic-value-heading">You Deserve The Very Best.</h2>
        
        <div className="kinetic-benefits">
          <div className="kinetic-benefit">
            <div className="kinetic-benefit-icon">
              <svg width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                <path d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L8 2.207l6.646 6.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5Z"/>
                <path d="m8 3.293 6 6V13.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5V9.293l6-6Z"/>
              </svg>
            </div>
            <h3 className="kinetic-benefit-title">No Congestion</h3>
            <p className="kinetic-benefit-desc">Fiber Internet Delivers Consistent Speeds With No Bandwidth Congestion.</p>
          </div>
          
          <div className="kinetic-benefit highlight">
            <div className="kinetic-benefit-icon">
              <svg width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"/>
                <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z"/>
              </svg>
            </div>
            <h3 className="kinetic-benefit-title">No Data Caps</h3>
            <p className="kinetic-benefit-desc">You Get Unlimited Data To Surf And Stream Without Limits Or Interruptions.</p>
          </div>
          
          <div className="kinetic-benefit">
            <div className="kinetic-benefit-icon">
              <svg width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                <path d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z"/>
                <path d="M7 5.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 1 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0z"/>
              </svg>
            </div>
            <h3 className="kinetic-benefit-title">No Annual Contracts</h3>
            <p className="kinetic-benefit-desc">Enjoy The Freedom To Modify Or Cancel Your Plan At Any Time Without Penalty.</p>
          </div>
        </div>
        
        <a href="tel:+18443172397" className="kinetic-cta-button">
          1 (844) 317-2397
        </a>
      </section>

      {/* Service Offerings */}
      <section className="kinetic-services">
        <h2 className="kinetic-services-heading">Whatever You Need, Kinetic Can Deliver.</h2>
        
        <div className="kinetic-service-list">
          <div className="kinetic-service">
            <div className="kinetic-service-icon">
              <svg width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"/>
                <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z"/>
              </svg>
            </div>
            <h3 className="kinetic-service-title">Ultra-Fast Fiber Internet</h3>
            <p className="kinetic-service-desc">Reliable Internet For Your Home Or Business On Our Fiber-Backed Network.</p>
          </div>
          
          <div className="kinetic-service">
            <div className="kinetic-service-icon">
              <svg width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                <path d="M2.5 13.5A.5.5 0 0 1 3 13h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zM13.991 3l.024.001a1.46 1.46 0 0 1 .538.143.757.757 0 0 1 .302.254c.067.1.145.277.145.602v5.991l-.001.024a1.464 1.464 0 0 1-.143.538.758.758 0 0 1-.254.302c-.1.067-.277.145-.602.145H2.009l-.024-.001a1.464 1.464 0 0 1-.538-.143.758.758 0 0 1-.302-.254C1.078 10.502 1 10.325 1 10V4.009l.001-.024a1.46 1.46 0 0 1 .143-.538.758.758 0 0 1 .254-.302C1.498 3.078 1.675 3 2 3h11.991zM14 2H2C0 2 0 4 0 4v6c0 2 2 2 2 2h12c2 0 2-2 2-2V4c0-2-2-2-2-2z"/>
              </svg>
            </div>
            <h3 className="kinetic-service-title">TV & Entertainment</h3>
            <p className="kinetic-service-desc">Start Streaming With Best-In-Class Live Entertainment.</p>
          </div>
          
          <div className="kinetic-service">
            <div className="kinetic-service-icon">
              <svg width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                <path d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"/>
              </svg>
            </div>
            <h3 className="kinetic-service-title">Voice Services</h3>
            <p className="kinetic-service-desc">Unlimited Nationwide Voice Calling With Kinetic Phone Service.</p>
          </div>
        </div>
        
        <img 
          src={provider6}
          alt="Connected world" 
          className="kinetic-globe-image" 
        />
      </section>

      {/* Plan Options Section */}
      <section className="kinetic-plans">
        <h2 className="kinetic-plans-heading">Whatever You Need, Kinetic Can Deliver.</h2>
        
        <div className="kinetic-plan-cards">
          {plans.map(plan => (
            <div key={plan.id} className={`kinetic-plan-card ${plan.featured ? 'featured' : ''}`}>
              <h3 className="kinetic-card-title">{plan.title}</h3>
              <p className="kinetic-card-subtitle">{plan.subtitle}</p>
              <div className="kinetic-price-container">
                <span className="kinetic-dollar">$</span>
                <span className="kinetic-price-number">{plan.price}</span>
                <span className="kinetic-price-period">{plan.period}</span>
              </div>
              <ul className="kinetic-features-list">
                {plan.features.map((feature, index) => (
                  <li key={index} className="kinetic-feature">✓ {feature}</li>
                ))}
              </ul>
              <a href="tel:+18443172397" className="kinetic-plan-cta">
                1 (844) 317-2397
              </a>
            </div>
          ))}
        </div>
        
        <p className="kinetic-disclaimer">
          Prices include a $5/mo discount with AutoPay. Subject to details at sign date. Prices and terms subject to change.
        </p>
      </section>
    </div>
    <WideCoverage/>
    <Footer/>
    </>
  );
};

export default KineticsProvider;